export const iconFontAwesomeMoneyFrancSign = (
	<i className="fa-solid fa-franc-sign"></i>
);
